import { useEffect, useRef, useState } from "react";
import { useInboxColumnWidths } from "@/pages/chat/hooks/useInboxColumnWidths";
import { MobileInboxPaneController } from "@/lib/MobileInboxPaneController";
import ColumnSplitter from "@/pages/chat/components/ColumnSplitter";

/**
 * Three-column ticketing layout on desktop; one pane at a time on small screens.
 */
export default function TicketingResizableShell({ list, thread, details, selectedId = null }) {
  const { containerRef, leftWidth, rightWidth, leftGripProps, rightGripProps } = useInboxColumnWidths();
  const paneCtrlRef = useRef(null);
  if (!paneCtrlRef.current) {
    paneCtrlRef.current = new MobileInboxPaneController();
  }
  const [mobilePane, setMobilePane] = useState("list");

  useEffect(() => {
    setMobilePane(paneCtrlRef.current.onSelectionChange(selectedId));
  }, [selectedId]);

  return (
    <div className="flex min-h-0 w-full min-w-0 flex-1 flex-col overflow-hidden bg-app-canvas">
      {mobilePane !== "list" ? (
        <div className="flex shrink-0 items-center gap-2 border-b border-slate-200 bg-white px-3 py-2 md:hidden dark:border-slate-700 dark:bg-slate-900">
          <button
            type="button"
            className="rounded-lg px-2 py-1 text-sm font-semibold text-teal-700"
            onClick={() => setMobilePane(paneCtrlRef.current.back())}
          >
            Back
          </button>
          {mobilePane === "thread" ? (
            <button
              type="button"
              className="ml-auto rounded-lg px-2 py-1 text-sm font-semibold text-slate-600"
              onClick={() => setMobilePane(paneCtrlRef.current.showDetails())}
            >
              Details
            </button>
          ) : null}
        </div>
      ) : null}

      <div ref={containerRef} className="flex min-h-0 w-full min-w-0 flex-1 overflow-hidden bg-app-canvas">
        <div
          className={`${mobilePane === "list" ? "flex" : "hidden"} inbox-shell-col-left h-full min-h-0 min-w-0 max-md:w-full flex-col overflow-hidden border-r border-slate-200/70 bg-white md:flex md:shrink-0 md:grow-0 dark:border-slate-700/70 dark:bg-slate-900/95`}
          style={{ "--inbox-left": `${leftWidth}px` }}
        >
          <div className="h-full min-h-0 w-full">
            {list}
          </div>
        </div>

        <ColumnSplitter gripProps={leftGripProps} />

        <div
          className={`${mobilePane === "thread" ? "flex" : "hidden"} h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-app-canvas md:flex`}
        >
          {thread}
        </div>

        <ColumnSplitter gripProps={rightGripProps} />

        <div
          className={`${mobilePane === "details" ? "flex" : "hidden"} inbox-shell-col-right h-full min-h-0 min-w-0 max-md:w-full flex-col overflow-hidden border-l border-slate-200/70 bg-white md:flex md:shrink-0 md:grow-0 dark:border-slate-700/70 dark:bg-slate-900/95`}
          style={{ "--inbox-right": `${rightWidth}px` }}
        >
          <div className="h-full min-h-0 w-full">
            {details}
          </div>
        </div>
      </div>
    </div>
  );
}
